import { render, staticRenderFns } from "./ExpandableDataTableChild.vue?vue&type=template&id=7626669d&scoped=true&"
import script from "./ExpandableDataTableChild.vue?vue&type=script&lang=js&"
export * from "./ExpandableDataTableChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7626669d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7626669d')) {
      api.createRecord('7626669d', component.options)
    } else {
      api.reload('7626669d', component.options)
    }
    module.hot.accept("./ExpandableDataTableChild.vue?vue&type=template&id=7626669d&scoped=true&", function () {
      api.rerender('7626669d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Overview/ExpandableDataTable/ExpandableDataTableChild.vue"
export default component.exports